import { getUserData } from "@/auth/getUserData";
import useMessagingStatusFilters from "@/composables/v2.1/useMessagingStatusFilters";
// @ts-ignore
import i18n from "@/libs/i18n";
import { ChatsListChat, EntryDtoType } from "@saysimple-platform/dtos";

export const resolveStatusFilter = (chat: Pick<ChatsListChat, "status" | "assignedUserId" | "assignedTeamId">) => {
    const { statusFilters } = useMessagingStatusFilters();

    if (chat.status.toLowerCase() === "open") {
        if (!chat.assignedUserId && !chat.assignedTeamId) {
            return statusFilters.new;
        }

        if (chat.assignedUserId && chat.assignedUserId === getUserData().id) {
            return statusFilters.personal;
        }

        if (chat.assignedUserId) {
            return statusFilters.open;
        }

        if (!chat.assignedUserId && chat.assignedTeamId) {
            return statusFilters.team;
        }
    } else {
        return statusFilters.archive;
    }
};

// @note this one is not working for the backend result of fetching chats list, because not the full
// entry data is available. For consistency, I commented this and only use the "resolveLastEntryPayload" based on chat.
export const resolveEntryPayload = (entry: EntryDtoType) => {
    switch (entry.type) {
        case "event":
            //return resolveEventEntryPayload(entry); // @todo for future
            return entry.name;
        case "location":
            return entry.name ?? `${entry.latitude} ${entry.longitude}`;
        case "information":
            return entry.variant; // @todo maybe change?
        case "text":
        case "attachment":
            return entry.message;
    }
};

// This is specifically for the last entry in the chats list based on chat instead of entry.
// That body payload differs from the websockets payload where an full entry is included.
export const resolveLastEntryPayload = (chat: ChatsListChat) => {
    let lastEntryPayload: string;

    switch (chat.lastMessageEntryType) {
        case "event":
            lastEntryPayload = i18n.t(`events.${chat.lastMessageEntryPayload}`);
            break;
        case "information":
            // @note JSON object.
            lastEntryPayload = JSON.parse(chat.lastMessageEntryPayload as string);
            break;
    }

    return lastEntryPayload ?? chat.lastMessageEntryPayload;
};

export const textIsOnlyEmoji = (text: string) => {
    const regexExp =
        /^(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])$/gi;

    return regexExp.test(text);
};
